import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Image from 'react-bootstrap/lib/Image';
import Row from 'react-bootstrap/lib/Row';
import { Link } from 'react-router-dom';
import './PreApp.css';
import './static/bootstrap/css/bootstrap.min.css';
import './static/style.css';

const Box = ({ type, name }) => (
  <Col
    xs={6}
    md={6}
    style={{ margin: '0px', padding: '0px', height: '100%', flex: 1 }}
  >
    <Link to={'/?type=' + type.toLowerCase()}>
      <div className="preApp">
        <p className="name">{name}</p>
        <p className="type">{type}</p>
      </div>
    </Link>
  </Col>
);

export const PreApp = () => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      width: '100vw',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '30px',
    }}
  >
    <Image
      alt="logo"
      src="https://s3-eu-west-1.amazonaws.com/www.birdseyeagency.com/logo.png"
      style={{ height: '100px' }}
    />
    <Row>
      <Box name="The Music Company Booking" type="Booking" />
      <Box name="The Music Company Backman" type="Management" />
    </Row>
  </div>
);



// WEBPACK FOOTER //
// ./src/PreApp.js